import React, { useState } from "react";
import { operationService } from "../../../../../services/operation.services";
import { Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Select from "react-select";

const Index = ({ setActivePage,getOperation,suggestedSets }) => {
    const [modalerror, setModalError] = useState("");
    const [addNewModal, setAddNewModal] = useState(false);
    const [name, setName] = useState("");
    const [selectedSuggestedSets,setSelectedSuggestedSets] = useState([]);
    const [addSuggestedSets,setAddSuggestedSets] = useState([]);

    const addOperation = () => {
        const addOperation = { name: name,suggestedSets:addSuggestedSets };

        operationService
            .addOperationsList(addOperation)
            .then((res) => {
                console.log(res);
                setAddNewModal(false);
                setActivePage(1);
                getOperation();
                setName("");
                setModalError("");
            })
            .catch((error) => {
                console.log(error);
                setModalError(error.name[0]);
            });
    };

    const nameHandler = (e) => {
        setName(e.target.value);
    };

    const handleSubmit = () => {
        addOperation();
    };

    //console.log(addNewModal);
    const addNewModalOpen = () => {
        setAddNewModal(true);
        setName("");
        setSelectedSuggestedSets([]);
        setAddSuggestedSets([]);
        setModalError("");
    };

    const addNewModalClose = () => {
        setName("");
        setSelectedSuggestedSets([]);
        setAddSuggestedSets([]);
        setAddNewModal(false);
        setModalError("");
    };

    const setSelectedOptionSuggestedSets = selectedSuggestedSets => {
        var tempSuggestedSets = [];
        selectedSuggestedSets.map(item => {
            tempSuggestedSets.push(item.value);
        });

        setAddSuggestedSets(tempSuggestedSets);
        setSelectedSuggestedSets(selectedSuggestedSets);
    };

    return (
        <>
            <button
                className="btn btn-primary add_option"
                onClick={addNewModalOpen}
            >
                <i className="fa fa-plus"></i> <span>Add New</span>
            </button>

            <Modal
                size="md"
                backdrop="static"
                isOpen={addNewModal}
                toggle={addNewModalClose}
            >
                <ModalHeader className="" toggle={addNewModalClose}>
                    Add New Operation
                </ModalHeader>
                <ModalBody>
                    <form className="">
                        <div className="form-group row">
                            <div className="col">
                                <label>Operation name</label>
                                <Input
                                    type="text"
                                    className="form-control"
                                    onChange={nameHandler}
                                />
                                <span className="text-danger">
                                    {modalerror}
                                </span>
                            </div>
                        </div>
                        
                        <div className="form-group">
                            <label>Add Suggested sets{" "}
                            </label>
                            <Select
                                value={selectedSuggestedSets}
                                onChange={setSelectedOptionSuggestedSets}
                                options={suggestedSets}
                                isMulti={true}
                            />
                        </div>

                    </form>
                </ModalBody>
                <ModalFooter>
                    <div className="">
                        <button
                            onClick={addNewModalClose}
                            className="btn btn-secondary mr-2"
                            data-dismiss="modal"
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default Index;
